<template>
  <div class="container">
    <content-header :data="[{text: '红包一览', path: '/redenvelope/list'},{text:(curObj.id ? '修改':'添加')+'红包', path: ''}]"></content-header>
    <div class="content">
      <el-form :model="curObj" :rules="curObjRules" ref="curObjForm" label-position="right" label-width="0px">
        <el-form-item prop="name" label="红包名称" :label-width="formLabelWidth">
          <el-input name="name" v-model="curObj.name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item prop="categoryId" label="红包类型" :label-width="formLabelWidth">
          <el-select v-model="curObj.categoryId" clearable value-key="id" placeholder="请选择类型">
            <el-option
              v-for="item in categoryIds"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="money" label="红包金额" :label-width="formLabelWidth">
          <el-input name="money" v-model="curObj.money" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="活动时间" :label-width="formLabelWidth" required>
          <el-col :span="6">
            <el-form-item prop="startTime">
              <el-date-picker type="date" placeholder="开始日期" v-model="curObj.startTime" value-format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="1"><span>至</span></el-col>
          <el-col :span="6">
            <el-form-item prop="endTime">
              <el-date-picker placeholder="结束日期" v-model="curObj.endTime" value-format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item prop="brand" label="关联品牌" :label-width="formLabelWidth">
          <el-input name="brand" v-model="curObj.brand" placeholder="品牌名称" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item prop="product" label="关联商品" :label-width="formLabelWidth">
          <el-input name="product" v-model="curObj.product" placeholder="商品编号" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item prop="lotteryId" label="关联抽奖" :label-width="formLabelWidth">
          <el-input name="lotteryId" v-model="curObj.lotteryId" placeholder="抽奖活动编号" auto-complete="off"></el-input>
        </el-form-item>

        <el-form-item prop="image" label="红包图片" :label-width="formLabelWidth">
          <el-upload
            class="avatar-uploader"
            action="//upload-z2.qiniup.com"
            :data="uploadForm"
            :show-file-list="false"
            :on-success="uploadPhotoSuccess"
            :before-upload="beforePhotoUpload"
            :on-error="uploadError">
            <img v-if="curObj.image" :src="domainPic + curObj.image" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item prop="description" label="红包说明" :label-width="formLabelWidth">
          <ky-editor v-model="curObj.description"
            ref="myQuillEditor">
          </ky-editor>
        </el-form-item>
        <el-form-item prop="advertising" label="广告文字" :label-width="formLabelWidth">
          <ky-editor v-model="curObj.advertising"
            ref="myQuillEditor">
          </ky-editor>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth">
          <el-button @click="isObjShow = false">取 消</el-button>
          <el-button type="primary" @click="confirmHandle">确 定</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script type="text/babel">
  import constants from 'config/constants'
  import date from 'utils/date'
  import RedEnvelopeModel from 'models/redenvelope'
  import CommonModel from 'models/common'
  import KyEditor from 'components/KyEditor'

  export default {
    components: {
      KyEditor,
    },
    data () {
      var validateEndTime = (rule, value, callback) => {
        if (value === '') {
          // callback(new Error('请再次输入密码'));
        } else if (value <= this.curObj.startTime) {
          callback(new Error('结束日期必须晚于开始日期!'))
        } else {
          callback()
        }
      }
      var validateMoney = (rule, value, callback) => {
        if (value === '') {
          // callback(new Error('请再次输入密码'));
        } else if (value < 1) {
          callback(new Error('红包金额要大于等于1!'))
        } else {
          callback()
        }
      }
      return {
        domainPic: constants.basic.domain_pic,
        isObjShow: false,
        categoryIds: [],
        curObj: {
          id: '',
          name: '',
          categoryId: '',
          money: 1,
          startTime: '',
          endTime: '',
          image: '',
          description: '',
          advertising: '',
          brand: '',
          product: '',
          lotteryId: '',
        },
        formLabelWidth: '80px',
        curObjRules: {
          name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
          categoryId: [{ required: true, message: '请选择类型', trigger: 'blur' }],
          money: [{ required: true, message: '请输入金额', trigger: 'blur' },
            { validator: validateMoney, trigger: 'blur' }],
          startTime: [{ required: true, message: '请输入开始日期', trigger: 'blur' }],
          endTime: [{ required: true, message: '请输入结束日期', trigger: 'blur' },
            { validator: validateEndTime, trigger: 'blur' }],
          description: [{ required: true, message: '请输入红包说明', trigger: 'blur' }],
          brand: [{ required: true, message: '请输入关联的品牌名称', trigger: 'blur' }],
          product: [{ required: true, message: '请输入关联的产品编号', trigger: 'blur' }],
        },
        //
        uploadForm: {key: '', token: ''},
        qiniuHost: '',
        datePickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近三个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }]
        },
      }
    },
    created () {
      //
      this.curObj.id = this.$route.query.id
      console.log(this.curObj.id)
      if (this.curObj.id) {
        RedEnvelopeModel.get({
          id: this.curObj.id
        }).then(res => {
          this.curObj = res
          this.curObj.startTime = this.curObj.startTime.substr(0, 10)
          this.curObj.endTime = this.curObj.endTime.substr(0, 10)
          console.log(this.curObj)
        })
      }
      RedEnvelopeModel.findCategory({curPage: 1, pageSize: 1000}).then(res => {
        // console.log(res)
        this.categoryIds = res.rows
      })
    },
    methods: {
      uploadRemove (file, fileList) {
        console.log(file)
      },
      uploadError (err, file, fileList) {
        console.log(err)
      },
      uploadExceed (files, fileList) {
        console.log(files.length)
      },
      uploadPhotoSuccess (response, file, fileList) {
        // console.log(response)
        this.curObj.image = response.key
      },
      beforePhotoUpload (file) {
        const isPic = (file.type === 'image/jpeg' || file.type === 'image/png')
        const isLt2M = file.size / 1024 / 1024 < 2

        if (!isPic) {
          this.$message.error('上传头像图片只能是 JPG/PNG 格式!')
          return false
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!')
          return false
        }
        //
        if (!this.uploadForm.token) {
          return CommonModel.getQiniuUptoken().then(res => {
            this.qiniuHost = res.qiniuHost
            this.uploadForm.token = res.uptoken
            let curr = date(new Date().getTime(), 'yyyyMMdd')
            let prefix = 'redenvelope'
            let suffix = file.name
            this.uploadForm.key = encodeURI(`${prefix}/${curr}_${suffix}`)
            console.log(this.uploadForm)
          })
        } else {
          let curr = date(new Date().getTime(), 'yyyyMMdd')
          let prefix = 'redenvelope'
          let suffix = file.name
          this.uploadForm.key = encodeURI(`${curr}/${prefix}_${suffix}`)
          console.log(this.uploadForm)
        }
        return true
      },
      confirmHandle () {
        this.$refs.curObjForm.validate(valid => {
          if (!valid) return
          if (this.curObj.id) return this.editHandle()
          this.newHandle()
        })
      },
      newHandle () {
        RedEnvelopeModel.create({
          name: this.curObj.name,
          categoryId: this.curObj.categoryId,
          money: this.curObj.money,
          startTime: this.curObj.startTime + ' 00:00:00',
          endTime: this.curObj.endTime + ' 23:59:59',
          image: this.curObj.image,
          description: this.curObj.description,
          advertising: this.curObj.advertising,
          brand: this.curObj.brand,
          product: this.curObj.product,
          lotteryId: this.curObj.lotteryId === '' ? 0 : this.curObj.lotteryId
        }).then(() => {
          // this.$router.push({ name: 'redenvelope.list', query: {id: this.curPid, pid: 0, sid: this.subjectId} })
          this.$router.push({ name: 'redenvelope.list' })
          this.$message({ message: '添加成功', type: 'success' })
        }).catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
      },
      editHandle () {
        RedEnvelopeModel.update({
          id: this.curObj.id,
          name: this.curObj.name,
          categoryId: this.curObj.categoryId,
          money: this.curObj.money,
          startTime: this.curObj.startTime + ' 00:00:00',
          endTime: this.curObj.endTime + ' 23:59:59',
          image: this.curObj.image,
          description: this.curObj.description,
          advertising: this.curObj.advertising,
          brand: this.curObj.brand,
          product: this.curObj.product,
          lotteryId: this.curObj.lotteryId === '' ? 0 : this.curObj.lotteryId
        }).then(() => {
          this.$message({ message: '更新成功', type: 'success' })
          this.$router.push({ name: 'redenvelope.list' })
        }).catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.container
  min-height: 100%
  background-color: #fff
  .content
    padding: 20px
    font-size: 14px
    .el-input
      width: 50%
    .textarea
      width: 80%
    .avatar-uploader
        border: 1px dashed #d9d9d9
        border-radius: 6px
        cursor: pointer
        position: relative
        overflow: hidden
        width: 180px
        &:hover
          border-color: #409EFF
        .avatar-uploader-icon
          font-size: 28px
          color: #8c939d
          width: 178px
          height: 178px
          line-height: 178px
          text-align: center
        .avatar
          width: 178px
          height: 178px
          display: block
</style>



// WEBPACK FOOTER //
// src/views/RedEnvelopeNew.vue